<template>
  <div class="title-line">
    <div class="line"></div>
    <div class="text">{{text}}</div>
    <div class="line"></div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    props: {
      text: {
        type: String
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  .title-line
    display:flex
    flex-direction:row
    white-space:nowrap
    .line
      flex:1
      margin-top:7px
      border-top:solid 1px rgba(255, 255, 255, 0.2)
    .text
      margin:0px 12px
      font-size:14px
      font-weight:700
      line-height:14px
      color:#fff
</style>



// WEBPACK FOOTER //
// titleline.vue?6b796f89